var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav vue-alerts",attrs:{"mode":_vm.activeMode}},[(_vm.hasAlerts)?_c('NotificationList',{staticClass:"vue-alerts__items",attrs:{"items":_vm.alerts,"showingNavigation":_vm.showingNavigation},on:{"dismissClick":_vm.onNotificationDismissed,"saveClick":_vm.onNotificationDismissed}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }